import cx from 'classnames';

import {AnimatedText, Screen} from '#component/base';
import {EmptyNotice, Hero} from '#component/partial';
import {Transition} from '#component/util';
import {withRequireUserState} from '#component/util/RequireUserState/RequireUserState';
import {pageSlideInKeyframe} from '#style/keyframes.css';
import {sprinkles} from '#style/sprinkles';

export const ResearchScreen = () => (
  <Screen
    pageName="Research"
    className={sprinkles({bg: 'ecruWhite'})}
    headerProps={{variant: 'dark'}}
    withDefaultSizing={false}>
    <Hero showOverlap={false}>
      <Transition
        appear
        className={cx(
          sprinkles({layout: 'grid', pB: [80, 80, 192], pT: [80, 128]}),
          pageSlideInKeyframe,
        )}
        show>
        <AnimatedText
          className={sprinkles({
            colSpan: [4, 6, 4],
            colStart: [1, 2],
            dir: 'col',
            flex: ['auto', 'flex'],
          })}
          color="inherit"
          variant="heading1">
          Research coming soon!
        </AnimatedText>

        <AnimatedText
          className={cx(
            sprinkles({
              colSpan: [4, 6, 5],
              colStart: [1, 2, 7],
              dir: 'col',
              flex: 'flex',
              gap: 24,
              pT: [40, 40, 0],
            }),
            pageSlideInKeyframe,
          )}
          color="inherit"
          variant="bodyLarge">
          Access scientific papers, external articles, and our very own Tally’s Take opinion
          articles by our team of scientists within our Tally Health Research Hub coming soon!
        </AnimatedText>
      </Transition>
    </Hero>

    <div className={cx(sprinkles({layout: 'grid'}), pageSlideInKeyframe)}>
      <EmptyNotice
        className={sprinkles({colSpan: [4, 4, 6], colStart: [1, 3, 4], pY: [80, 80, 128]})}
        body="We’re cataloging all of our research to make this library easy to use."
        icon="Books"
      />
    </div>
  </Screen>
);

export const Research = withRequireUserState(ResearchScreen, {userState: 'verified'});
